import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to clear settings tab state when navigating away from settings page
 */
export const useSettingsTabCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    const isSettingsPage = location.pathname === '/settings';
    if (!isSettingsPage) {
      localStorage.removeItem('settings_activeTab');
    }
  }, [location.pathname]);
};

